import { inject, Injectable } from '@angular/core';
import { IdentityStore } from '../stores/IdentityStore';
import { WebCashPermissionKeys } from '../../../../core/enums/WebCashPermissionKeys';
import { JwtUtils } from '../../../../core/utils/JwtUtils';

/** JWT permissions from cinetixx-api WebCash login are Edit-only; presence of a key is the grant. */
interface WebCashPermission {
  key?: string;
  Key?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private readonly _identityStore = inject(IdentityStore);

  public hasPermission(key: WebCashPermissionKeys): boolean {
    const permissions = this.getPermissions();

    if (!permissions) {
      return false;
    }

    return permissions.some(permission => {
      const permissionKey = permission.key ?? permission.Key;

      return permissionKey === key;
    });
  }

  private getPermissions(): WebCashPermission[] | null {
    const accessToken = this._identityStore.identity()?.accessToken ?? this._identityStore.tmpIdentity()?.accessToken;
    const payload = JwtUtils.decodePayload<{ permissions?: string | WebCashPermission[] }>(accessToken);

    if (!payload) {
      return null;
    }

    try {
      const permissionsClaim = payload.permissions;
      const permissions = typeof permissionsClaim === 'string'
        ? JSON.parse(permissionsClaim)
        : permissionsClaim;

      return Array.isArray(permissions) ? permissions : null;
    } catch {
      return null;
    }
  }
}
